const getReadableFromDateRange = (startDate?: number | null, endDate?: number | null): string => {
    if (!endDate || !startDate) return '';
    let timeDifference = endDate - startDate;
    const sign = timeDifference < 0 ? '-' : '';
    timeDifference = Math.abs(timeDifference / 1000);
    const days = Math.floor((timeDifference / 86400000) % 24);
    const hours = Math.floor((timeDifference / 3600) % 24);
    const minutes = Math.floor((timeDifference / 60) % 60);
    const seconds = Math.floor(timeDifference % 60);
    return `${sign}${days ? ` ${days}d` : ''}${
        hours ? ` ${hours}h` : ''
    }${` ${minutes}m`}${` ${seconds}s`}`;
};

export default getReadableFromDateRange;
